import { useToast } from '@lifebit-ai/lds'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { extractErrorMessage } from 'core/utils'
import { bulkAssignDataAccessRequests } from 'services/data-access-requests'
import { DataAccessRequestQueryKeys } from 'services/data-access-requests/queryKeys'
import type { BulkAssignDataAccessRequestsParams } from 'services/data-access-requests/types'
import { invalidateRequestActivityQueries } from 'services/request-activity/invalidateRequestActivityQueries'
import type { ApiErrorResponse } from 'services/types'
import { isAirlockRequestsV3RoutesEnabled } from 'utils/env'

interface UseBulkAssignDataAccessRequestsParams {
  onSuccess?: () => void
}

export const useBulkAssignDataAccessRequests = ({ onSuccess }: UseBulkAssignDataAccessRequestsParams = {}) => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation<void, ApiErrorResponse, BulkAssignDataAccessRequestsParams>({
    mutationFn: params => {
      if (!isAirlockRequestsV3RoutesEnabled()) {
        return Promise.resolve()
      }

      return bulkAssignDataAccessRequests(params)
    },
    onSuccess: () => {
      toast({ message: 'Data access requests assigned successfully' })
      queryClient.invalidateQueries({ queryKey: DataAccessRequestQueryKeys.All() })
      invalidateRequestActivityQueries(queryClient)
      onSuccess?.()
    },
    onError: error => {
      toast({ message: extractErrorMessage(error, 'Failed to assign data access requests') })
    }
  })
}
